import store from '@/store'
import settingsAPI from '@/modules/settings/api/settings'

export default {
  async incrementProjectNumber (div) {
    div.next_project_number += 1
    div = await settingsAPI.updateDivision(div)
    store.dispatch('loadDivisions', await settingsAPI.getDivisions())
  }
}